class ProgressPlayButton {
	constructor(el) {
		this.element = el

		this.getVideoProgress(this.element)
	}

	getVideoProgress(controls) {
		const video = controls.parentElement.querySelector("video")
		const progressDiv = controls.querySelector(".progress")
		const ctrlButton = controls.querySelector("rect.progress-target")
		const playIcon = controls.querySelector("path.play-icon")
		const pauseIcon = controls.querySelectorAll("path.pause-icon")
		const strokeDasharray = ctrlButton.getTotalLength()
		ctrlButton.style.strokeDasharray = strokeDasharray
		pauseIcon.forEach((icon) => {
			icon.style.opacity = "0"
		})

		let videoDuration
		let videoCurrentTime

		controls.addEventListener("click", function () {
			if (video.paused) {
				video.play()
				pauseIcon.forEach((icon) => {
					icon.style.opacity = "1"
				})
				playIcon.style.opacity = "0"
			} else {
				video.pause()
				pauseIcon.forEach((icon) => {
					icon.style.opacity = "0"
				})
				playIcon.style.opacity = "1"
			}
		})

		function updateProgressDisplay() {
			if (video && progressDiv) {
				const duration = video.duration
				const currentTime = video.currentTime
				const progressPercentage =
					duration > 0 ? (currentTime / duration) * 100 : 0

				const strokeDashoffset =
					strokeDasharray -
					(strokeDasharray * progressPercentage) / 100
				ctrlButton.style.strokeDashoffset = strokeDashoffset
			}
		}

		video.addEventListener("timeupdate", () => {
			updateProgressDisplay()
			videoCurrentTime = video.currentTime
		})

		video.addEventListener("loadedmetadata", () => {
			updateProgressDisplay()
			videoDuration = video.duration
		})
	}
}

export default ProgressPlayButton
